import React from 'react';

export const Modal = ({ isOpen, onClose, title, subtitle, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl max-w-5xl w-full max-h-[92vh] overflow-hidden border border-gray-200 dark:border-gray-700">
        <div className="flex justify-between items-start p-6 border-b border-gray-200 dark:border-gray-700">
          <div>
            <h3 className="text-2xl font-semibold text-gray-900 dark:text-white">{title}</h3>
            {subtitle && (
              <p className="mt-1 text-sm text-gray-500 dark:text-gray-400 text-left">{subtitle}</p>
            )}
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 focus:outline-none"
          >
            <svg className="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[calc(92vh-9rem)]">
          {children}
        </div>
      </div>
    </div>
  );
};

export const StatsCard = ({ label, value, helper }) => (
  <div className="min-w-[180px] rounded-xl border border-gray-200 dark:border-gray-700 bg-white/90 dark:bg-gray-800/90 px-4 py-3 shadow-sm">
    <div className="flex items-center justify-between gap-3">
      <div className="min-w-0">
        <p className="truncate text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">{label}</p>
        {helper && <p className="mt-1 truncate text-xs text-gray-400 dark:text-gray-500">{helper}</p>}
      </div>
      <p className="shrink-0 text-2xl font-semibold text-gray-900 dark:text-gray-100">{value}</p>
    </div>
  </div>
);

export const SectionCard = ({ title, subtitle, children, className = '', bodyClassName = '' }) => (
  <div className={`rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm ${className}`}>
    <div className="border-b border-gray-200 dark:border-gray-700 px-5 py-4">
      <h4 className="text-base font-semibold text-gray-900 dark:text-gray-100">{title}</h4>
      {subtitle && <p className="mt-1 text-sm text-gray-500 dark:text-gray-400 text-left">{subtitle}</p>}
    </div>
    <div className={`p-5 ${bodyClassName}`}>{children}</div>
  </div>
);
